import { useMemo } from 'react';
const generateId = () => `input_${Math.random().toString().split('.')[1].substr(-8)}`;
export const useInputId = (external) => {
    const id = useMemo(() => {
        let result;
        if (external) {
            result = generateId();
        }
        if (typeof external === 'string') {
            result = external;
        }
        return result;
    }, [external]);
    return id;
};
//# sourceMappingURL=id.js.map